var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./data/keys'),
    keyAndStructParser = _require.keyAndStructParser,
    types = _require.types;

var parseV = require('./parseV');

var unArrayTypes = require('./utils/unArrayTypes');

var _require2 = require('./data/keys'),
    generateStructArr = _require2.generateStructArr,
    mp4ValidSamples = _require2.mp4ValidSamples;

var breathe = require('./utils/breathe'); //quick function to find the last, most relevant fourCC key


function findLastCC(data, start, end) {
  var ks;

  while (start < end) {
    //Retrieve structured data
    var length = 0;

    try {
      var tempKs = keyAndStructParser.parse(data.slice(start)).result;
      if (tempKs.fourCC !== "\0\0\0\0") ks = tempKs; //But don't process it, go to next

      length = ks.size * ks.repeat;
    } catch (error) {
      setImmediate(function () {
        return console.error(error);
      });
    }

    var reached = start + 8 + (length >= 0 ? length : 0); //Align to 32 bits

    while (start < reached) {
      start += 4;
    }
  }

  if (ks) return ks.fourCC;
} //is it better to slice the data when recursing? Or just pass indices? we have to slice anyway when parsing


function parseKLV(_x) {
  return _parseKLV.apply(this, arguments);
}

function _parseKLV() {
  _parseKLV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var options,
        start,
        end,
        parent,
        unarrayLast,
        result,
        unknown,
        complexType,
        lastCC,
        _loop,
        _ret,
        key,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            start = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 0;
            end = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : data.length;
            parent = _args2.length > 4 ? _args2[4] : undefined;
            unarrayLast = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : true;
            result = {}; //Will store unknown types

            unknown = new Set(); //Will store complex type definitions

            complexType = []; //Find the last, most relevant key

            lastCC = findLastCC(data, start, end); //Undo unarraying of last if this is a valid sample structure, despite being an mp4Header

            if (mp4ValidSamples.includes(lastCC)) unarrayLast = true; //Remember last key for interpreting data later

            result.interpretSamples = lastCC; //Check if the lastCC is to be filtered out by options, but keep GPS5 for timing if lists or timein is MP4

            if (!(parent === 'STRM' && options.stream && !options.stream.includes(lastCC) && (lastCC !== 'GPS5' || options.timeIn === 'MP4' && !options.raw || options.streamList || options.deviceList))) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 13:
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var length, ks, done, partialResult, unArrayLastChild, parsed, axes, environment, specifics, i, extraDescription, newValueArr, extraDescString, reached;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      length = 0;
                      ks = void 0;
                      _context.prev = 2;

                      if (!(start % 20000 === 0)) {
                        _context.next = 6;
                        break;
                      }

                      _context.next = 6;
                      return breathe();

                    case 6:
                      try {
                        //Parse the first 2 sections (64 bits) of each KLV to decide what to do with the third
                        ks = keyAndStructParser.parse(data.slice(start)).result; //Get the length of the value (or values, or nested values)

                        length = ks.size * ks.repeat;
                      } catch (error) {} //Abort if we are creating a device list. Or a streamList and We have enough info


                      done = !ks || ks.fourCC === "\0\0\0\0" || options.deviceList && ks.fourCC === 'STRM' || options.streamList && ks.fourCC === lastCC && parent === 'STRM';

                      if (done) {
                        _context.next = 53;
                        break;
                      }

                      partialResult = [];
                      unArrayLastChild = true; //Decide if no sample interpretation is needed for children

                      if (ks.fourCC === 'STRM' && options.mp4header) {
                        unArrayLastChild = false;
                      }

                      if (!(length >= 0)) {
                        _context.next = 52;
                        break;
                      }

                      if (!(length === 0)) {
                        _context.next = 17;
                        break;
                      }

                      partialResult.push(undefined); //Log unknown types for future implementation

                      _context.next = 48;
                      break;

                    case 17:
                      if (types[ks.type]) {
                        _context.next = 21;
                        break;
                      }

                      unknown.add(ks.type); //Recursive call to parse nested data

                      _context.next = 48;
                      break;

                    case 21:
                      if (!types[ks.type].nested) {
                        _context.next = 32;
                        break;
                      }

                      if (!(data.length >= start + 8 + length)) {
                        _context.next = 29;
                        break;
                      }

                      _context.next = 25;
                      return parseKLV(data, options, start + 8, start + 8 + length, ks.fourCC, unArrayLastChild);

                    case 25:
                      parsed = _context.sent;
                      if (parsed != null) partialResult.push(parsed);
                      _context.next = 30;
                      break;

                    case 29:
                      partialResult.push(undefined);

                    case 30:
                      _context.next = 48;
                      break;

                    case 32:
                      if (!(types[ks.type].func || types[ks.type].complex && complexType)) {
                        _context.next = 47;
                        break;
                      }

                      //Detect data with multiple axes
                      axes = 1;
                      if (types[ks.type].size > 1) axes = ks.size / types[ks.type].size; //Detect them when the type is complex
                      else if (types[ks.type].complex && complexType.length) axes = complexType.length; //Human readable strings should de merged for readability

                      if (types[ks.type].func === 'string' && ks.size === 1 && ks.repeat > 1) {
                        ks.size = length;
                        ks.repeat = 1;
                      }

                      environment = {
                        data: data,
                        options: options,
                        ks: ks
                      };
                      specifics = {
                        ax: axes,
                        complexType: complexType
                      }; //Access the values or single value

                      if (ks.repeat > 1) {
                        for (i = 0; i < ks.repeat; i++) {
                          partialResult.push(parseV(environment, start + 8 + i * ks.size, ks.size, specifics));
                        }
                      } else partialResult.push(parseV(environment, start + 8, length, specifics)); //If we just read a TYPE value, store it. Will be necessary in this nest


                      if (!(ks.fourCC === 'TYPE')) {
                        _context.next = 43;
                        break;
                      }

                      complexType = unArrayTypes(partialResult[0]); //Abort if we are selecting devices and this one is not selected

                      _context.next = 45;
                      break;

                    case 43:
                      if (!(ks.fourCC === 'DVID' && parent === 'DEVC' && options.device && !options.device.includes(partialResult[0]))) {
                        _context.next = 45;
                        break;
                      }

                      return _context.abrupt("return", {
                        v: undefined
                      });

                    case 45:
                      _context.next = 48;
                      break;

                    case 47:
                      unknown.add(ks.type);

                    case 48:
                      //Try to define unknown data based on documentation
                      if (ks.fourCC === lastCC && generateStructArr(ks.fourCC)) {
                        //Create the string for inside the parenthesis, and remove nulls
                        extraDescription = generateStructArr(ks.fourCC).filter(function (v) {
                          return v != null;
                        });
                        newValueArr = []; //Loop partial results

                        partialResult.forEach(function (p, i) {
                          //Will become the description if it's the most comprehensive one
                          var descCandidate = [];
                          var newP = []; //Loop the keys in the description

                          generateStructArr(ks.fourCC).forEach(function (e, ii) {
                            //For nested arrays
                            if (Array.isArray(p) && e != null) {
                              //Push label and value if not null (in order to get rid of unused data)
                              descCandidate.push(e);
                              newP.push(p[ii]); //And for values, push first label
                            } else if (ii === 0 && e != null) descCandidate.push(e);
                          }); //Save new values if worth it

                          if (newP.length) partialResult[i] = newP;
                          if (descCandidate.length > extraDescription.length) extraDescription = descCandidate;
                        });
                        if (newValueArr.length) partialResult[0] = newValueArr;

                        if (extraDescription.length) {
                          extraDescString = extraDescription.join(',');

                          if (!/\(.+\)$/.test(result.STNM)) {
                            result.STNM = "".concat(result.STNM || '', " (").concat(extraDescString, ")");
                          } else if (result.STNM.match(/\((.+)\)$/)[1].length < extraDescString.length) {
                            result.STNM.replace(/\(.+\)$/, "(".concat(extraDescString, ")"));
                          }
                        }
                      } //Handle data with multiple samples. Not easy


                      if (result.hasOwnProperty(ks.fourCC)) {
                        if (parent === 'STRM') {
                          if (!result.multi) result[ks.fourCC] = [result[ks.fourCC]];
                          result[ks.fourCC].push(partialResult);
                          result.multi = true;
                        } else result[ks.fourCC] = result[ks.fourCC].concat(partialResult);
                      } else result[ks.fourCC] = partialResult; //Parsing error


                      _context.next = 53;
                      break;

                    case 52:
                      throw Error('Error, negative length');

                    case 53:
                      _context.next = 62;
                      break;

                    case 55:
                      _context.prev = 55;
                      _context.t0 = _context["catch"](2);

                      if (!options.tolerant) {
                        _context.next = 61;
                        break;
                      }

                      setImmediate(function () {
                        return console.error(_context.t0);
                      });
                      _context.next = 62;
                      break;

                    case 61:
                      throw _context.t0;

                    case 62:
                      //Advance to the next KLV, at least 64 bits
                      reached = start + 8 + (length >= 0 ? length : 0); //Align to 32 bits

                      while (start < reached) {
                        start += 4;
                      }

                    case 64:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop, null, [[2, 55]]);
            });

          case 14:
            if (!(start < end)) {
              _context2.next = 21;
              break;
            }

            return _context2.delegateYield(_loop(), "t0", 16);

          case 16:
            _ret = _context2.t0;

            if (!(typeof _ret === "object")) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 19:
            _context2.next = 14;
            break;

          case 21:
            //Undo all arrays except the last key, which should be the array of samples (except for mp4 headers)
            for (key in result) {
              if ((!unarrayLast || key !== lastCC) && result[key] && result[key].length === 1) {
                result[key] = result[key][0];
              }
            } //If debugging, print unexpected types


            if (options.debug && unknown.size) setImmediate(function () {
              return console.warn('unknown types:', _toConsumableArray(unknown).join(','));
            });
            return _context2.abrupt("return", result);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _parseKLV.apply(this, arguments);
}

module.exports = parseKLV;